<template>
    <v-btn
        v-bind="bindProps"
        :color="color"
        :disabled="disabled"
        :loading="loading"
        class="px-4"
        :class="appendIcon ? 'pr-2' : ''"
        @click="$emit('click', $event)"
    >
        <slot />
        <v-icon v-if="appendIcon">
            {{ appendIcon }}
        </v-icon>
    </v-btn>
</template>

<script>
export default {
    name: "PrimaryButton",
    props: {
        bindProps: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        appendIcon: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'primary'
        }
    }
}
</script>

<style scoped>

</style>